// extracted by mini-css-extract-plugin
export default {"container":"load-more_container__eiXDW","link":"load-more_link__dwNnu"};